export const setTokens = (accessToken: string, refreshToken: string) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  
    const expirationTime = new Date().getTime() + 60 * 60 * 1000;
    localStorage.setItem('tokenExpiration', expirationTime.toString());
  };
  